import {HINT_CATEGORY, toHintId} from '../../../../../packages/Hints/Hints.types'
import type {Hint} from '../../../../../packages/Hints/Hints.types'

export const buildTypeInfoPanelHint: Hint = {
  id: toHintId('trend-card'),
  name: 'Trends',
  text: 'Trends are mini panels that represent build configurations and allow viewing and managing the recent builds. Explore its handy controls by hovering over them.',
  category: HINT_CATEGORY.projectOverview,
}
